export default __webpack_public_path__ + "static/media/structural-design.1dead86d.png";